/**
 * In-memory cache for fetched owner histories (#585 AC5/AC6).
 *
 * Module scope, not component state: the point is that reopening the panel —
 * or opening it from a different grid — costs nothing, and a Leads user's
 * Maskinporten budget is small enough that paying twice for the same plate is
 * a real cost.
 *
 * Deliberately NOT localStorage, sessionStorage or IndexedDB. The response
 * carries the full name and address of private owners (the backend drops
 * fodselsdato, not the rest), so persisting it would write named individuals
 * to the client's disk and leave them there after the session. A module-level
 * Map dies with the page, which is the retention policy the issue asks for.
 *
 * Errors are never cached — a 429 today must not become a permanent "no".
 */
import type { EierhistorikkResponse } from '../../Oppslag/oppslagApi'

const cache = new Map<string, EierhistorikkResponse>()

/** Plates are stored and displayed with varying spacing ("EB11111" vs "EB 11111"). */
function nokkel(kjennemerke: string): string {
  return kjennemerke.replace(/\s+/g, '').toUpperCase()
}

export function lesHistorikk(kjennemerke: string): EierhistorikkResponse | undefined {
  return cache.get(nokkel(kjennemerke))
}

export function skrivHistorikk(
  kjennemerke: string,
  svar: EierhistorikkResponse,
): void {
  cache.set(nokkel(kjennemerke), svar)
}

/** Test seam. Nothing in the app clears the cache — a reload does that. */
export function tomHistorikkCache(): void {
  cache.clear()
}
